import * as React from "react";

export const ShortcutBlankIcon = (props: any) => (
  <svg
    width={12}
    height={12}
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M7 .5v1h2.781l-6.14 6.14.718.72L10.5 2.218V5h1V.5H7Zm-6.5 2v9h9V5l-1 1v4.5h-7v-7H6l1-1H.5Z"
      fill="#333"
    />
  </svg>
);
